<template>
    <section>
        <page-header>
            <slot slot="title">Dashboard</slot>
            <slot slot="description">
                <p>{{ $t('intro.salesman_dashboard') }}</p>
            </slot>
            <slot slot="action">
                <v-customer-search></v-customer-search>
            </slot>
        </page-header>

        <v-overview-list
                data-table="PreOrders"
                data-filter="PreOrdersFilters"
                data-pagination="PreOrdersPagination"
                btnViewPath="SalesmanPreOrdersEdit"
                filter-theme="white"
                :filters="PreOrders.filters"
                :table-columns="PreOrders.columns"
                :btnCopy="false"
                :page-size="6"
                :title="$t('preorder_overview.running_negotiations')"
                prefix="lop">

            <template slot="placeholderButtons">
                <router-link class="c-button c-button--icon c-button--alpha u-flex--push-left" to="/salesman/pre-orders/create">
                    <svgicon name="added"></svgicon>
                    <span>{{ $t('preorder_overview.assign_new') }}</span>
                </router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import Vue from 'vue'
    import PageHeader from '@/components/common/PageHeader'
    import VCustomerSearch from '@/components/form/customerSearch/CustomerSearch'
    import VOverviewList from '@/components/OverviewList'

    export default {
        props: {},
        components: {
            PageHeader,
            VCustomerSearch,
            VOverviewList
        },
        computed: {
            PreOrders() {
                return {
                    filters: [
                        { name: this.$t('preorder_overview.filters.brands'), value: 'Brands', single: 'brand', width:150 },
                        { name: this.$t('preorder_overview.filters.collections'), value: 'Collections', single: 'collection', width:150 },
                        { name: this.$t('preorder_overview.filters.customer'), value: 'Customers', single: 'customer', width:150 },
                        { name: this.$t('preorder_overview.filters.states'), value: 'States', single: 'state', width:150 }
                    ],
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name'), sortable: false },
                        { value: 'CustomerAltKey', name: this.$t('preorder_overview.columns.customer_key'), sortable: false },
                        { value: 'Customer', name: this.$t('preorder_overview.columns.customer'), sortable: false },
                        { value: 'InternalCustomerReference', name: this.$t('preorder_overview.columns.internal_customer_ref'), sortable: false },
                        { value: 'HasUnReadMessages', name: this.$t('preorder_overview.columns.messages'), type: 'Message', sortable: false },
                        { value: 'State', name: this.$t('preorder_overview.columns.state'), sortable: false },
                        { value: 'Deadline', name: this.$t('preorder_overview.columns.deadline'), type: 'Date', sortable: false }
                    ]
                };
            },
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";


</style>


// WEBPACK FOOTER //
// src/views/salesman/SalesmanZone.vue